import type { EnrichedMenuItem } from "../../src/types";
import { classify } from "../lib/glutenSummary";
import { GlutenPill } from "./GlutenPill";

export function MenuItem({ item }: { item: EnrichedMenuItem }) {
  const kind = classify(item.gluten);
  return (
    <li
      className={`menu-item gi-${kind} grid grid-cols-[56px_1fr] items-start gap-2.5 py-2 px-1 border-b border-(--color-line-2) last:border-b-0`}
    >
      <GlutenPill kind={kind} mini />
      <div className="min-w-0">
        <div className="menu-title font-medium text-[13px] text-(--color-ink)">{item.title}</div>
        {item.description && (
          <div className="text-[12px] text-(--color-ink-2) mt-px">{item.description}</div>
        )}
        {item.gluten.source === "inferred" && item.gluten.reasoning && (
          <div className="text-[11px] italic text-(--color-accent) mt-0.5">
            {item.gluten.reasoning}
          </div>
        )}
      </div>
    </li>
  );
}
